import { useState } from 'react';
import { ClientProgressBar } from "../inputs/ClientProgressBar";
import { CompletedMessage } from "./CompletedMessage";
import { GoCanvasLogo } from "./GoCanvasLogo";
import { formModeSelector, submitInProgressSelector, submissionSuccessfulSelector } from "../../store/selectors/clientSettings";
import { useSelector } from 'react-redux';
import Loader from 'react-loader-spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons';
export const TableSaveButton = ({
  nextAction
}) => <div className={`screen--controls control-group`}>
    <div className="add-table-entry--wrapper">
      <button className="foundry--button btn--sm button--active save-btn" onClick={nextAction}>
        SAVE
      </button>
    </div>
  </div>;
export const FormProgressBar = ({
  nextAction,
  percentComplete,
  interactive
}) => {
  const submitInProgress = useSelector(submitInProgressSelector);
  const submissionSuccessful = useSelector(submissionSuccessfulSelector);

  // should probably use this for button class as well, but pending style decisions
  const canSubmit = interactive && !submitInProgress && !submissionSuccessful;
  return <div className={`screen--controls control-group`}>
      <div className="indicator--wrapper">
        <div className="screen-indicator" style={{
        width: `${percentComplete}%`
      }}></div>
      </div>
      <button className={`foundry--button ${interactive ? 'button--active' : 'button--disabled'} btn--sm`} onClick={nextAction} disabled={!canSubmit}>
        <span className="button--label">
          {percentComplete < 100 ? 'Next' : 'Submit'}
        </span>
      </button>
    </div>;
};
export const WebFormProgressBar = ({
  nextAction,
  prevAction,
  reset,
  percentComplete,
  interactive,
  atStart,
  anySheetErrors
}) => {
  const [complete, setComplete] = useState(false);
  const liveForm = useSelector(formModeSelector) === 'live';
  const submitInProgress = useSelector(submitInProgressSelector);
  const submissionSuccessful = useSelector(submissionSuccessfulSelector);
  const showProgress = !liveForm || !complete || submitInProgress;
  const handleNext = () => {
    if (percentComplete === 100 && !complete && !anySheetErrors) {
      setComplete(true);
      return liveForm ? nextAction() : true;
    }
    setComplete(false);
    nextAction();
  };
  const handlePrev = () => {
    if (complete) {
      setComplete(false);
      return reset();
    }
    prevAction();
  };
  const topLevelClass = `preview-progress ${complete ? `preview-progress--complete` : ``}`;
  const prevDisabled = !complete && (!interactive || atStart);
  return <>
      {complete && submissionSuccessful && <CompletedMessage />}
      {complete && submissionSuccessful && <GoCanvasLogo />}
      {interactive && showProgress && <div className={topLevelClass}>
          <ClientProgressBar value={percentComplete} />
          <div className="preview-progress-buttons">
            <button className={`foundry--button ${prevDisabled || submitInProgress ? 'btn--tertiary--disabled' : 'btn--tertiary--active'} `} onClick={handlePrev} disabled={prevDisabled || submitInProgress}>
              <span className="button--label">
                <FontAwesomeIcon icon={faChevronLeft} role="img" />
                {`${complete && !liveForm ? ' Restart Test' : ' Previous'}`}
              </span>
            </button>
            {complete && !liveForm && <div className="preview-progress-message">
                This is a preview of the message displayed at the end of a
                submission. No actual submission has been made.
              </div>}
            <button className={`foundry--button ${interactive ? 'button--active' : 'button--disabled'}`} onClick={handleNext} disabled={!interactive || submitInProgress}>
              <Loader className="preview-progress-submit-loader" type="TailSpin" visible={submitInProgress} height={23} width={23} />
              <span className={`button--label ${submitInProgress ? 'preview-progress-next-button-label-hide' : 'preview-progress-next-button-label-show'}`}>
                {complete && !submitInProgress ? 'Back to Builder' : percentComplete < 100 ? 'Next' : 'Submit'}
              </span>
            </button>
          </div>
        </div>}
    </>;
};
const ProgressBars = {
  webform: WebFormProgressBar,
  builder: FormProgressBar,
  table: TableSaveButton
};
export const ProgressBar = ({
  type = 'builder',
  nextAction,
  prevAction,
  percentComplete,
  interactive,
  reset,
  atStart,
  anySheetErrors
}) => {
  const ProgressBarComponent = ProgressBars[type];
  const progressBarProps = {
    nextAction,
    prevAction,
    percentComplete,
    interactive,
    atStart,
    reset,
    anySheetErrors
  };
  return <ProgressBarComponent {...progressBarProps} />;
};